import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import { findAllDecisionFilterPageable } from '../../../actions/decision';
import Form from '../../Reusable/Form/Form';
import { config } from './DecisionConfig';
import withTranslations from '../../../utils/HighOrderComponent';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dot from 'dot-object';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import '../../../styles/scss/app/DecisionForm.scss';
import { findAllDecisionTypes } from '../../../actions/decisionType';
import { decisionStatus } from '../../../constants/globals';

const DecisionFilter = ({
  t,
  findAllDecisionFilterPageable,
  saveFilters,
  initialValues,
  initialStateValues,
  savePostData,
  setResetData,
  findAllDecisionTypes,
  decisionTypeList,
  enums,
  pageSize,
}) => {
  useEffect(() => {
    findAllDecisionTypes();
  }, [findAllDecisionTypes]);

  const { AccordionForm } = t || {};

  const [activeKey, setActiveKey] = useState('-1');
  const decisionTypeNameList = decisionTypeList?.map((type) => type.name) || [];
  const { fields } = config(t, decisionTypeNameList, decisionStatus, enums);
  const decoratedOnClick = useAccordionToggle('0', () => {
    setActiveKey('-1');
  });

  const handleSubmit = (values) => {
    const dotNotationObj = dot.dot(values);

    const postData = {
      tableName: 'decision',
      filterCriteria: Object.entries(dotNotationObj)
        .map((entry) => {
          if (
            entry[0] === 'createdAtFrom' ||
            entry[0] === 'createdAtTo' ||
            entry[0] === 'submitDateFrom' ||
            entry[0] === 'submitDateTo'
          ) {
            if (
              values.createdAtFrom !== initialValues.createdAtFrom ||
              values.createdAtTo !== initialValues.createdAtTo
            )
              return {
                columnName: 'createdAt',
                dateMin: values.createdAtFrom,
                dateMax: values.createdAtTo,
                logicalOperator: '><',
              };
            if (
              values.submitDateFrom !== initialValues.submitDateFrom ||
              values.submitDateTo !== initialValues.submitDateTo
            )
              return {
                columnName: 'requestForSignetApproval.submitDate',
                dateMin: values.submitDateFrom,
                dateMax: values.submitDateTo,
                logicalOperator: '><',
              };
          } else if (entry[0].includes('decisionStatus')) {
            return (
              (values.decisionStatus?.value ||
                values.decisionStatus.value === 0) && {
                columnName: 'decisionStatus',
                columnValue: values.decisionStatus.value,
              }
            );
          } else if (entry[0].includes('kjs')) {
            return (
              entry[1] && {
                columnName: 'kjs.name',
                columnValue: entry[1],
              }
            );
          } else {
            return (
              entry[1] && {
                columnName: entry[0],
                columnValue: entry[1],
              }
            );
          }
          return null;
        })
        .filter((item) => !!item),
    };
    if (postData.filterCriteria?.length === 0) {
      resetFilters();
    } else {
      savePostData(postData);
      findAllDecisionFilterPageable(postData, pageSize, () =>
        saveFilters(values)
      );
    }
  };

  const packConfig = () => {
    return {
      fields: [...fields],
    };
  };

  const packTranslations = () => {
    return {
      ...t,
    };
  };

  const resetFilters = () => {
    savePostData(null);
    setResetData(true);
    return saveFilters(initialStateValues);
  };
  const filterCardStyle =
    activeKey === '0' ? 'form-row card-header-open' : 'form-row';
  return (
    <div className="Filters m-auto">
      <Accordion activeKey={activeKey}>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            className={filterCardStyle}
            onClick={() => {
              if (activeKey !== '0') {
                setActiveKey('0');
              } else {
                setActiveKey('-1');
              }
            }}
          >
            <div className="float-left col-md-10">{AccordionForm.title}</div>
            {activeKey === '0' && initialValues !== initialStateValues && (
              <div className="col-md-2  text-right">
                <Button
                  variant="warning"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  {AccordionForm.reset}
                </Button>
              </div>
            )}
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ paddingTop: '-2vh' }}>
              <Form
                className="DecisionForm"
                onSubmit={handleSubmit}
                initialValues={initialValues}
                formConfig={packConfig()}
                translations={packTranslations()}
                removeCancel={true}
                submitLabel={AccordionForm.filter}
                decoratedOnClick={decoratedOnClick}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => ({
  decisionTypeList: state.decisionType.decisionTypeList || [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllDecisionFilterPageable: (postData, pageSize, successCallback) => {
      dispatch(
        findAllDecisionFilterPageable(0, pageSize, postData, successCallback)
      );
    },
    findAllDecisionTypes: () => {
      dispatch(findAllDecisionTypes());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslations(DecisionFilter, 'DecisionFilter'))
);
